import { render, staticRenderFns } from "./CacheControl.vue?vue&type=template&id=4683fd5a&"
import script from "./CacheControl.vue?vue&type=script&lang=js&"
export * from "./CacheControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports